import { ProductFeatureAccountParticipationModelDto } from '@treasury/api/bo';
import { DomainEntity } from '../../../../../shared';

export class ProductFeatureAccountParticipation extends DomainEntity<ProductFeatureAccountParticipationModelDto> {
    constructor(dto: ProductFeatureAccountParticipationModelDto) {
        super(dto);
    }

    public createDefault(): this {
        throw new Error('Method not implemented.');
    }

    public get accountNumber() {
        return this.dto.accountNumber;
    }

    public get accountId() {
        return this.dto.accountId;
    }

    public get accountType() {
        return this.dto.accountType;
    }

    public get cifNumber() {
        return this.dto.cifNumber;
    }

    public get isParticipating() {
        return this.dto.isParticipating;
    }

    public set isParticipating(value: boolean) {
        this.dto.isParticipating = value;
    }
}
